import { render, staticRenderFns } from "./ProfileNew.vue?vue&type=template&id=43e13f16&scoped=true&"
import script from "./ProfileNew.vue?vue&type=script&lang=js&"
export * from "./ProfileNew.vue?vue&type=script&lang=js&"
import style0 from "./ProfileNew.vue?vue&type=style&index=0&id=43e13f16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e13f16",
  null
  
)

export default component.exports